import axios from "axios";

export function getAreas() {
  return axios.get('/api/dbc/client/taxAuthGuide')
}